wbApp.filter('onlinePaymentState', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_NONE');
            case 1:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_CREATED');
            case 2:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_PENDING');
            case 3:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_PAID');
            case 4:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_REVERSED');
            case 5:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_AUTOREVERSED');
            case 6:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_CANCELLED');
            case 7:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_DECLAINED');
            case 8:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_ERROR');
            case 9:
                return $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_MANUALLY_REVERSED');                
        }
        
    };
}]);